export const ajaxItems = () => {
  const readMoreButton = document.querySelector(`[data-read-more-button]`);
  if (!readMoreButton) {
    return;
  }
  let url = `${window.homeUrl}/wp-content/themes/selfit-furisode/template-parts/ajax-item-${window.postType}.php`;
  // 最初に表示されている記事数 window.postNumNow が未定義の場合はデフォルト値として12
  let postNumNow = window.postNumNow || 12;
  // 追加する記事数 window.postNumAdd が未定義の場合はデフォルト値として12
  let postNumAdd = window.postNumAdd || 12;
  if (postNumNow >= window.postCountJson) {
    readMoreButton.classList.add("is-hidden");
  }
  readMoreButton.addEventListener("click", () => {
    $.ajax({
      type: "POST",
      url: url,
      data: {
        post_num_now: postNumNow,
        post_num_add: postNumAdd,
        post_ids: window.postIdsJson,
      },
      success: (response) => {
        $(".articles-inner").append(response);
        postNumNow += postNumAdd;
        if (postNumNow >= window.postCountJson) {
          readMoreButton.classList.add("is-hidden");
        }
      },
    });
  });
};
